import { TableEmptyState } from '@practium/ui';
import type { Manufacturer } from '../../../types';
import styles from '../DefensivesTable/DefensivesTable.module.css';

interface ManufacturersTableProps {
	manufacturers: Manufacturer[];
	onRowClick?: (id: string) => void;
}

export const ManufacturersTable = ({ manufacturers, onRowClick }: ManufacturersTableProps) => {
	if (manufacturers.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum fabricante encontrado"
				subtitle="Adicione um fabricante para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome Comercial</th>
						<th>Nome Fantasia</th>
						<th>CNPJ</th>
						<th>Origem</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{manufacturers.map((item) => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.tradingName ?? '—'}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.businessName ?? '—'}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.cnpj ?? '—'}</span>
							</td>
							<td>
								<span
									className={`${styles.originBadge} ${
										item.isPublic ? styles.originBadgeAdmin : styles.originBadgeClient
									}`}
								>
									{item.isPublic ? 'Admin' : 'Cliente'}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
